import React, { useEffect, useRef, useState } from 'react';

const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

// Anime un nombre de 0 jusqu'à `value` une seule fois quand il devient disponible.
// Respecte prefers-reduced-motion (affiche directement la valeur finale dans ce cas).
const AnimatedNumber = ({ value, duration = 1400, formatter = (n) => n.toLocaleString('fr-FR') }) => {
  const [display, setDisplay] = useState(0);
  const hasAnimatedRef = useRef(false);

  useEffect(() => {
    if (value === null || value === undefined) return;
    if (hasAnimatedRef.current) {
      setDisplay(value);
      return;
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      setDisplay(value);
      hasAnimatedRef.current = true;
      return;
    }

    hasAnimatedRef.current = true;
    const start = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = easeOutCubic(progress);
      setDisplay(Math.round(eased * value));
      if (progress < 1) requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return <>{formatter(display)}</>;
};

export default AnimatedNumber;
